import { render } from "./AwarenessFlow.vue?vue&type=template&id=76c22d8e"
import script from "./AwarenessFlow.vue?vue&type=script&lang=js"
export * from "./AwarenessFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__